import React, { useState } from 'react'

import {
  UPDATE,
  DELETE,
} from 'react-admin'

import Cookies from 'js-cookie'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import IconButton from '../../../../elements/IconButton'
import CKEditorField from '../../../../elements/CKEditorField'
import FileInfo from '../../../../elements/files/FileInfo'
import AttachFileButton from '../../../../elements/files/AttachFileButton'
import AnswersTable from "../../../../elements/AnswersTable";

const acceptedUploadFileFormats = ['.pdf,.doc,.docx,.xls,.xlsx']

const styles = {
  textAreaWrap: {
    '& label': {
      padding: '0 15px'
    },
    '& .cke_editable': {
      padding: '0 15px'
    }
  },
  editWrap: {
    border: '1px solid #ddd',
    marginBottom: '15px'
  },
  change: {
    fontSize: '14px',
    cursor: 'pointer'
  },
  fileAreaWrap: {
    marginBottom: '15px',
    display: 'flex',
  },
  buttonsWrap: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  pointsAreaWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '250px',
    marginBottom: '50px'
  },
  fileUpload: {
    flex: 1
  },
  attachedFiles: {
    marginTop: '15px',
  },
  label: {
    display: 'block',
    color: 'rgba(0, 0, 0, 0.54)',
  }
}

const CaseSegmentQuestion = props => {
  let {
    classes,
    item: {
      id,
      content,
      answer,
      mark,
      balls,
      applicantAttaches,
      expertAttaches,
      number,
      symbols,
      answerSymbols,
      markSymbols,
      ballsInfo
    },
    dataProvider,
    dispatch,
    status,
    module
  } = props

  const [showModal, setShowModal] = useState<boolean>(false)

  const onSuccess = {
    onSuccess: {
      notification: { body: 'Сохранено', level: 'info' },
    },
    onError: {
      notification: { body: 'Произошла ошибка', level: 'warning' },
    }
  }

  /**
   * Сохранили изменения в подвопросе.
   */
  const role = Cookies.get('role')
  // форматируем комментарии по изменениям
  const formatValue = (value) => {
    if (role === 'expertReviewer') {
      let text = value
      let node = document.createElement('div')
      node.innerHTML = text
      let list = node.querySelectorAll('[data-username]')
      list.forEach((item) => {
        const username = item.getAttribute('data-changedata')
        if (username.length > 0) {
          item.setAttribute('data-changedata', '')
          item.setAttribute('data-username', username)
        }
      })
      return node.innerHTML
    }

    return value
  }

  const saveQuestion = () => {
    content = formatValue(content)
    dataProvider(UPDATE, 'segments', {
      id,
      url: 'case-questions',
      data: {
        content,
        mark,
        answer,
        balls,
        ballsInfo
      }
    }, onSuccess)
  }

  /**
   * Удалили подвопрос.
   */
  const deleteQuestion = async () => {
    await dataProvider(DELETE, 'segments', {
      id,
      url: 'case-questions',
    }, { onSuccess, refresh: true })

    dispatch({ type: 'deleteQuestion', id })
  }

  /**
   * Изменили значение ячейки в оценочном листе.
   * @param row строка
   * @param attribute атрибут
   * @param value новое значение
   */
  const onCellChange = (row, attribute, value) => {
    ballsInfo[row][attribute] = value
    dispatch({ type: 'editQuestion', id, ballsInfo: ballsInfo})
  }

  /**
   * Изменяет max значение в оценочном листе.
   * @param value
   */
  const onTotalChange = (value) => {
    dispatch({
      type: 'editQuestion',
      id,
      balls: value
    })
  }

  /**
   * Удалили строку в оценочном листе.
   * @param row номер строки
   */
  const onRowRemove = (row) => {
    ballsInfo.splice(row, 1)
    dispatch({ type: 'editQuestion', id, ballsInfo: ballsInfo})
  }

  /**
   * Новая строка в оценочном листе.
   */
  const onRowAdd = () => {
    ballsInfo.push({
      number: '',
      mark: '',
      maxBalls: '',
      correctValues: '',
      solution: ''
    })
    dispatch({ type: 'editQuestion', id, ballsInfo: ballsInfo})
  }

  /**
   * Считает общий балл и возвращает его.
   * @param table оценочный лист
   */
  const calculateTotalBall = (table) => {
    let total = 0

    table.map((row) => {
      if (row.maxBalls) {
        total += parseFloat(row.maxBalls)
      }
    })

    dispatch({
      type: 'editQuestion',
      id,
      balls: total
    })
  }

  return (
    <>
      <div className={classes.editWrap}>
        <CKEditorField
          classes={classes.textAreaWrap}
          label={`Подвопрос №${number}`}
          initialValue={content}
          cb={content => dispatch({ type: 'editQuestion', id, content })}
          status={status}
          id={id}
          idType="caseQuestionId"
          entityForCase="null"
          save={saveQuestion}
          deleteEditor={() => setShowModal(true)}
          labelSave={`Сохранить подвопрос №${number}`}
          labelDelete={`Удалить подвопрос №${number}`}
          symbols={symbols}
        />
      </div>

      <div className={classes.editWrap}>
        <CKEditorField
          classes={classes.textAreaWrap}
          label="Ответ"
          initialValue={answer}
          cb={answer => dispatch({ type: 'editQuestion', id, answer })}
          isSmaller
          status={status}
          id={id}
          idType="caseQuestionId"
          entityForCase="answer"
          save={saveQuestion}
          deleteEditor={() => setShowModal(true)}
          labelSave="Сохранить ответ"
          labelDelete="Удалить ответ"
          symbols={answerSymbols}
          isDelete={false}
        />
      </div>
      <Dialog open={showModal} onClose={() => setShowModal(false)} aria-labelledby="alert-dialog-title">
        <DialogTitle id="alert-dialog-title">Вы действительно хотите удалить?</DialogTitle>
        <DialogActions>
          <Button className={classes.button} onClick={() => setShowModal(false)} color="primary">
            Нет
          </Button>
          <Button className={classes.button} onClick={deleteQuestion} color="primary">
            Да
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.editWrap}>
        <div className={classes.textAreaWrap}>
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <IconButton
              label="Сохранить"
              onClick={saveQuestion}
            />
          </div>
          <div style={{paddingBottom: '15px'}}>
            <div><label className={classes.label}>Оценочный лист</label></div>
          </div>
          <AnswersTable
            data={ballsInfo}
            totalBalls={balls}
            onCellChange={onCellChange}
            onTotalChange={onTotalChange}
            onRowRemove={onRowRemove}
            onRowAdd={onRowAdd}
            showAdditionText={module.id === 10 || module.id === 13}
          />
        </div>
      </div>
      <div className={classes.fileAreaWrap}>
        <div className={classes.fileUpload}>
          <AttachFileButton
            label="Прикрепить файл для эксперта"
            id={id}
            idSuffix="1"
            accept={acceptedUploadFileFormats}
            fileType="expert"
            dispatch={dispatch}
            dataProvider={dataProvider}
          />
          <div className={classes.attachedFiles}>
            {expertAttaches && expertAttaches.map(attach => (
              <FileInfo
                key={attach.id}
                title={attach.name}
                source={attach.filename}
                size={attach.size}
                attachId={attach.id}
                fileUrl={attach.url}
                fileType="expert"
                id={id}
                dataProvider={dataProvider}
                dispatch={dispatch}
              />
            ))}
          </div>
        </div>
        <div className={classes.fileUpload}>
          <AttachFileButton
            label="Прикрепить файл для претендента"
            id={id}
            idSuffix="2"
            accept={acceptedUploadFileFormats}
            fileType="applicant"
            dispatch={dispatch}
            dataProvider={dataProvider}
          />
          <div className={classes.attachedFiles}>
            {applicantAttaches && applicantAttaches.map(attach => (
              <FileInfo
                key={attach.id}
                title={attach.name}
                source={attach.filename}
                size={attach.size}
                attachId={attach.id}
                fileUrl={attach.url}
                fileType="applicant"
                id={id}
                dataProvider={dataProvider}
                dispatch={dispatch}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

export default withStyles(styles)(CaseSegmentQuestion)
